import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/dashboard/metrics/guide/")({
  head: () => ({
    meta: [{ title: "指标指南 · imiker CRM" }],
  })
});
